import {CloseOutlined} from '@ant-design/icons'
import styled from 'styled-components'

import {ErrorColor, WarningColor, SuccessColor} from '../../styles/_theme'

const DefineColor = ({type}) => {
  switch (type) {
    case 'success':
      return SuccessColor
    case 'warning':
      return WarningColor
    case 'error':
      return ErrorColor
    default:
      return ErrorColor
  }
}

export const AlertContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0px;
`

export const AlertBar = styled.div`
  position: absolute;
  top: -31px;
  left: -16px;
  height: calc(100% + 41px);
  width: 10px;
  background: ${DefineColor};
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
`

export const CloseIcon = styled(CloseOutlined)`
  &&& {
    padding: 0px 0px 0px 20px;
    color: #231f20;
    cursor: pointer;
    margin: 0;
  }
`

export const AlertTitle = styled.div`
  font-size: 18px;
  line-height: 21px;
  color: #231f20;
`

export const AlertDescription = styled.div`
  font-size: 14px;
  line-height: 16px;
  color: #231f20;
  margin-top: 10px;
`

export const AlertActions = styled.div`
  display: inline-block;
  width: 100%;
  margin-top: 20px;
  text-align: right;
  button {
    margin-left: 10px;
  }
`
